import React, {useState} from 'react';
import 'react-toastify/dist/ReactToastify.css';
import {Button, CircularProgress, DialogActions, DialogContent, DialogContentText} from '@mui/material';
import Dialog from "@mui/material/Dialog";


interface RejectOfferDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    reject: () => void;
}

function RejectOfferDialog({open, setOpen, reject}: RejectOfferDialogProps) {

    const [loading, setLoading] = useState(false);

    const handleReject = async () => {
        setLoading(true); // Enable loading state when "Yes" button is clicked
        try {
            await reject(); // Call the accept function passed from Offers component
            // Once the operation is complete, you can disable the loading state
            setLoading(false);
        } catch (error) {
            // Handle any errors here
            console.error("Error:", error);
            setLoading(false); // Disable loading state on error
        }
    };

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Are you sure you want to reject this offer? You can not accept it afterwards.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleReject} autoFocus disabled={loading}>
                    {loading ? <CircularProgress size={24}/> : 'Yes'}
                </Button>
                <Button onClick={() => setOpen(false)}>No</Button>
            </DialogActions>
        </Dialog>
    );
}

export default RejectOfferDialog;
